module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "panel box-collapse border-color-skin",
    attrs: {
      "id": "hres4ax-popup2"
    }
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showModal = true
      }
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRES4AXC4']['270']) + "\n      ")])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [(_vm.showModal) ? _c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container popuphres4ax"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", [_c('i', {
    staticClass: "fa fa-close close",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal()
      }
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.labels['STDPOSP1']['30']))])])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.labels['STDPOSP1']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.detail.desc_codcomp))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.labels['STDPOSP1']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.detail.desc_codlinef))])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._t("body", [_c('div', {
    attrs: {
      "id": "accordion2"
    }
  }, [_c('popup2-tab1', {
    attrs: {
      "labels": _vm.labels,
      "data": _vm.popup2.tab1
    }
  }), _vm._v(" "), _c('popup2-tab2', {
    attrs: {
      "labels": _vm.labels,
      "data": _vm.popup2.tab2,
      "popup2Tab2Table": _vm.popup2Tab2Table
    }
  }), _vm._v(" "), _c('popup2-tab3', {
    attrs: {
      "labels": _vm.labels,
      "data": _vm.popup2.tab3,
      "popup2Tab3Table": _vm.popup2Tab3Table
    }
  })], 1)])], 2)])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cd340d4e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres4ax/popup2.vue
// module id = 3977
// module chunks = 1